import React, { Fragment } from 'react';
import { Btn } from '../../../../AbstractElements';
import { DebitCard, ExpirationDate, SelectMonth, SelectYear, Submit } from '../../../../Constant';
import { Card, CardBody, Col, FormGroup, Input, Row, Label } from 'reactstrap';
import HeaderCard from '../../../Common/Component/HeaderCard';
import ActivityCard from '../../Task/ActivityCard';

const DebitCards = (props) => {
  return (
    <Fragment>
      <Col >
        <Card className='height-equal'>
           <CardBody>
            <Row >
             <ActivityCard eng="review-application" timelineData={props.timelineData} />
			 
            </Row>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};
export default DebitCards;
